import AccessibilityCertification from '@components/Images/Certifications/AccessibilityCertification';
import { StudioDesignLeagueCertification } from '@components/Images/Certifications/StudioDesignLeagueCertification';
import DeveloperCertification from '@components/Images/Certifications/StudioDevCertification';
import { StudioDevWebsitesLeagueCertification } from '@components/Images/Certifications/StudioDevWebsitesLeagueCertification';
import VeloCertification from '@components/Images/Certifications/VeloCertification';
import WebDesignerCertification from '@components/Images/Certifications/WebDesignerCertification';
import {
  CertificationType,
  AccountCertification,
} from '@wix/ambassador-academy-certifications-v1-account-certification/types';
import React from 'react';

export const CERTIFICATION_COLORS: Partial<Record<CertificationType, string>> =
  {
    [CertificationType.VELO]: '#E5DFF7',
    [CertificationType.WEB_DESIGNER]: '#D4E2F7',
    [CertificationType.ACCESSIBILITY]: '#B8F7D3',
    [CertificationType.STUDIO_DEVELOPER]: '#BBECDF',
  };

export const DEFAULT_CERTIFICATION_COLOR = '#BBECDF';

export const CertificationTypeToRenderDetails: Record<
  CertificationType,
  { Component: React.FC | null; label: string }
> = {
  [CertificationType.ACCESSIBILITY]: {
    Component: AccessibilityCertification,
    label: 'profile-page-certifications-accessibility',
  },
  [CertificationType.STUDIO_DEVELOPER]: {
    Component: DeveloperCertification,
    label: 'profile-page-certifications-studio-developer',
  },
  [CertificationType.WEB_DESIGNER]: {
    Component: WebDesignerCertification,
    label: 'profile-page-certifications-web-designer',
  },
  [CertificationType.VELO]: {
    Component: VeloCertification,
    label: 'profile-page-certifications-velo-developer',
  },
  [CertificationType.STUDIO_DESIGN_LEAGUE]: {
    Component: StudioDesignLeagueCertification,
    label: 'profile-page-certifications-studio-design-league',
  },
  [CertificationType.STUDIO_DEV_WEBSITES_LEAGUE]: {
    Component: StudioDevWebsitesLeagueCertification,
    label: 'profile-page-certifications-studio-dev-websites-league-full',
  },
  [CertificationType.UNKNOWN]: { Component: null, label: '' },
};

export const shouldRenderIndividualCertification = (
  certification: AccountCertification,
) => {
  return Boolean(
    CertificationTypeToRenderDetails[certification.certificationType!]
      ?.Component,
  );
};

export const getRenderedCertificationCount = (
  certifications: AccountCertification[] = [],
) => {
  return certifications.filter(shouldRenderIndividualCertification).length;
};

export const shouldRenderCertifications = (
  certifications: AccountCertification[] = [],
) => {
  return getRenderedCertificationCount(certifications) > 0;
};
